export default __webpack_public_path__ + "static/media/0010.0201dfd0.WAV";